<template>
    <NavBar :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <div>
        <H1>Page Not Found</H1>
    </div>
  <FooterPage />
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';

export default {

components: { NavBar, FooterPage},
 data() {
    return {

    }
 }
}
</script>